import { defineStore } from 'pinia'
import { ref } from 'vue'
import dayjs from 'dayjs'
import 'dayjs/locale/vi'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/en'
import {
  APP_LOCALES,
  getStoredLocale,
  LOCALE_STORAGE_KEY,
  setI18nLocale,
  type AppLocale,
} from '@/i18n'

const DAYJS_LOCALE: Record<AppLocale, string> = {
  vi: 'vi',
  zh: 'zh-cn',
  en: 'en',
}

export const useLocaleStore = defineStore('locale', () => {
  const locale = ref<AppLocale>(getStoredLocale())

  function applyDayjs(l: AppLocale) {
    dayjs.locale(DAYJS_LOCALE[l])
  }

  function setLocale(l: AppLocale) {
    if (!APP_LOCALES.includes(l)) return
    locale.value = l
    localStorage.setItem(LOCALE_STORAGE_KEY, l)
    applyDayjs(l)
    void setI18nLocale(l)
  }

  applyDayjs(locale.value)

  return { locale, setLocale }
})
